import React from "react";

import { dateDiffDays, dateIsInPast, isValidDate } from "util/dateUtils";
import styles from "./style.module.scss";

export const shouldRenderRecentlyUpdate = (dateTime: string, maxDays = 90) => {
  if (!dateTime || !dateTime.length) return null;
  const date = new Date(dateTime.substring(0, dateTime.indexOf("T")));

  if (!isValidDate(date)) return false;
  if (!dateIsInPast(date)) return false;
  if (dateDiffDays(date, new Date()) > maxDays) return false;
  return true;
};

const RecentlyUpdatedBadge = () => {
  return (
    <>
      <div
        data-jest="recently-updated-container"
        className={styles.recentlyUpdated}
      >
        <span className={`${styles.clockIcon} icon-clock`} />
        <span>Recently updated</span>
      </div>
    </>
  );
};

export default RecentlyUpdatedBadge;
